<ng-container *ngIf="isRequired()"><span>*</span></ng-container>
